module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A container for other components that adds an optional title/header and an appropriate bottom margin. </p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Section title=&quot;Section title&quot; sectionLevel={2}&gt;\n    &lt;p&gt;Section content goes here....&lt;/p&gt;\n&lt;/Section&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Section/README.md
// module id = 385
// module chunks = 0